// ===== Services =====

import {
    getParentAnnotationId,
}                           from '.';

// ===== Interfaces =====

import {
    IAnnotationItem,
    IAnnotationCommentItem,
}                           from '../interfaces';

const isAnnotationComment = (
    annotation: IAnnotationItem,
): annotation is IAnnotationCommentItem => getParentAnnotationId(annotation) != null;

export default isAnnotationComment;
